import { lazy } from "react";

const ManageUsers = lazy(() => import("pages/provider/ManageUsers"));
const AdminDashboard = lazy(() => import("pages/superadmin/AdminDashboard"));

const adminRoutes = [
  {
    path: "/manage-users",
    isExact: false,
    component: ManageUsers,
  },
  {
    path: "/admin/dashboard",
    isExact: true,
    component: AdminDashboard,
  },
];

export default adminRoutes;
